function lerp(a: number, b: number, t: number) {
  return Math.round(a + (b - a) * t);
}

// Returns an RGB color that transitions red → yellow → green based on fill fraction.
// 0.0 = red (#FF1E22), 0.5 = yellow (#FFD600), 1.0 = green (#A7FF1A)
export function gaugeColor(frac: number): string {
  const f = Math.min(Math.max(frac, 0), 1);
  let r: number, g: number, b: number;

  if (f < 0.5) {
    const t = f / 0.5;
    r = 255;
    g = lerp(30, 214, t);
    b = lerp(34, 0, t);
  } else {
    const t = (f - 0.5) / 0.5;
    r = lerp(255, 167, t);
    g = lerp(214, 255, t);
    b = lerp(0, 26, t);
  }

  return `rgb(${r},${g},${b})`;
}
